export const GOVERNANCE_AVAILABILITY = Object.freeze({
  AVAILABLE: "AVAILABLE",
  UNAVAILABLE: "UNAVAILABLE",
});

/** Mechanical boundary for the organization-wide, authoritative read model. */
export function investmentGovernancePositionAdapter(payload) {
  if (payload?.schema_version !== 1) {
    return { availability: GOVERNANCE_AVAILABILITY.UNAVAILABLE, reason: "UNSUPPORTED_SCHEMA", data: null };
  }

  return {
    availability: GOVERNANCE_AVAILABILITY.AVAILABLE,
    reason: null,
    source: {
      schemaVersion: payload.schema_version,
      generatedAt: payload.generated_at ?? null,
      scope: payload.scope ?? null,
    },
    position: {
      summary: payload.summary ?? null,
      responsibilities: payload.responsibilities ?? [],
      positions: payload.positions ?? [],
    },
    attention: {
      items: payload.attention_items ?? [],
      actionSummary: payload.governed_action_summary ?? null,
    },
    activity: {
      threads: payload.governance_threads ?? [],
      actions: payload.governed_actions ?? [],
      decisionContexts: payload.decision_contexts ?? [],
    },
    dataQuality: payload.data_quality ?? null,
    capitalPosition: payload.summary?.capital_position ?? null,
  };
}

export function adaptInvestmentGovernanceState(state) {
  if (state?.status === "ready") {
    const data = investmentGovernancePositionAdapter(state.data);
    return data.availability === GOVERNANCE_AVAILABILITY.AVAILABLE
      ? { status: "ready", reason: null, data }
      : { status: "unavailable", reason: data.reason, data: null };
  }
  return {
    status: state?.status || (state?.loading ? "loading" : "unavailable"),
    reason: state?.reason ?? null,
    data: null,
  };
}
